module.exports = __webpack_public_path__ + "static/media/liquid_70_detail.93cad48a.jpg";